import { all, fork } from 'redux-saga/effects'
import flyersSagas from './flyers.sagas'
import flyerGibsSagas from './flyerGibs.sagas'
import productsSagas from './products.sagas'
import tagsSagas from './tags.sagas'
import brandsSagas from './brands.sagas'
import storesSagas from './stores.sagas'
import userSagas from './user.sagas'
import routerSagas from './router.sagas'
import uiSagas from './ui.sagas'
import trackingSagas from './tracking.sagas'
import viewerSagas from './viewer.sagas'
import propertySagas from './property.sagas'
import applicationSagas from './application.sagas'
import dialogSagas from './dialog.sagas'
import sectionChangeSagas from './sectionChange.sagas'
import retailerCartSagas from './retailerCart.sagas'


const rootSaga = function* rootSaga() {
  yield all([
    fork(flyersSagas),
    fork(flyerGibsSagas),
    fork(productsSagas),
    fork(tagsSagas),
    fork(brandsSagas),
    fork(storesSagas),
    fork(userSagas),
    fork(routerSagas),
    fork(uiSagas),
    fork(trackingSagas),
    fork(viewerSagas),
    fork(propertySagas),
    fork(applicationSagas),
    fork(sectionChangeSagas),
    fork(dialogSagas),
    fork(retailerCartSagas),
  ])
}

export default rootSaga
